/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Segment, Divider, Form, Checkbox,
  Input, Dimmer, Loader, Button, Dropdown,
  Grid, Modal, Icon, Popup
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "components/login-config/configuration/UpdateLoader";

import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const UtilsInstance = new Utils();

const wifiModeList = [
  {
    key: Constants.DHCP_MODE,
    text: Strings.DHCP,
    value: Constants.DHCP_MODE,
  },
  {
    key: Constants.FIXED_IP_MODE,
    text: Strings.FIXED_IP,
    value: Constants.FIXED_IP_MODE
  }
];

const hiddenSSIDList = [
  {
    key: true,
    text: Strings.YES,
    value: true,
  },
  {
    key: false,
    text: Strings.NO,
    value: false,
  }
];

export class WLANConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isLoadingDimmerActive: false,
      isLoadingConfigDimmerActive: false,
      isTurnningWifiOnOffDimmerActive: false,
      isConfigDimmerActive: false,
      isUpdateHostnameDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
      // Hostname
      hostname: "",
      // ETHERNET config info
      addr: "",
      netmask: "",
      // Wi-fi config info
      wifiMode: "",
      hiddenSSID: false,
      wifiNameList: [],
      wifiName: "",
      wifiAddr: "",
      wifiNetmask: "",
      wifiGateway: "",
      wifiDNS: "",
      wifiPwd: "",
      pwdType: "password",
      pwdIcon: "eye slash",
      // Wi-fi info
      ip: "",
      ssid: "",
      mac: "",
      signalStrength: "",
      signalFrequency: "",
      signalQuality: "",
      channel: "",
      isWifiOn: false,
      turningWifiOnOffText: "",
      interval: null,
      // Wi-fi status
      status: ""
    };
    this.updateLoaderRef = React.createRef();
  }

  retrieveData = async () => {
    this.showLoadingConfigDimmer();
    this.showLoadingDimmer();

    // Wi-fi config
    await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiList", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ wifiNameList: this.buildWifiList(data) }));

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        wifiMode: data.wifiMode,
        hiddenSSID: data.hiddenSSID,
        wifiName: data.wifiName,
        wifiAddr: data.wifiAddr,
        wifiNetmask: data.wifiNetmask,
        wifiGateway: data.wifiGateway,
        wifiDNS: data.wifiDNS,
        wifiPwd: data.wifiPwd,
      }, () => {
        this.hideLoadingConfigDimmer();
      }))
      .catch(() => {
        this.hideLoadingConfigDimmer();
      })
      .finally(() => {
        this.switchWifiNameFieldsVisibility();
      });

    // Wi-fi ON/OFF
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "isWifiOn", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ isWifiOn: data.isWifiOn }))
      .finally(this.hideTurningWifiOnOffDimmer);

    // Wi-fi Info
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiInfo", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        ip: data.my_ip,
        ssid: data.ESSID,
        mac: data.address,
        signalStrength: data.signal,
        signalFrequency: data.frequency,
        signalQuality: data.quality,
        channel: data.channel
      }, () => {
        this.hideLoadingDimmer();
      }))
      .catch(() => {
        this.hideLoadingDimmer();
      });

    // Wi-fi status
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ status: data.status }));

    // Hostname
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "hostname", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ hostname: data.hostname }));

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "config", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        addr: data.addr,
        netmask: data.netmask,
      }));
  }

  getWifiStatusText = (status) => {
    if (status === Constants.CONNECTED_STATUS) {
      return (
        <p>
          <Icon name="circle" color="green" />
          {Strings.CONNECTED}
        </p>
      );
    }
    else if (status === Constants.DISCONNECTED_STATUS) {
      return (
        <p>
          <Icon name="circle" color="red" />
          {Strings.DISCONNECTED}
        </p>
      );
    }
    else {
      return (
        <p>
          <Icon name="circle" color="grey" />
          {Strings.UNKNOWN}
        </p>
      );
    }
  }

  toggleIsWifiOnCheckbox = async () => {
    // Se o adaptador wlan estiver desligado
    if (!this.state.isWifiOn) {
      // Verifique se o monitor consegue encontrá-lo primeiro
      let WifiAdapterDetected = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiOnUsb", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.wifiOnUsb);

      // Se o adaptador wifi não tiver sido encontrado, quer dizer que existe algum problema
      // de hardware, dê ao usuário as possíveis soluções
      if (!WifiAdapterDetected) {
        let msg = Strings.WLAN_ADAPTER_NOT_FOUND_1;
        msg += Strings.WLAN_ADAPTER_NOT_FOUND_2;
        msg += Strings.WLAN_ADAPTER_NOT_FOUND_3;
        msg += Strings.WLAN_ADAPTER_NOT_FOUND_4;

        alert(msg);
      }
      else {
        this.changeWifiStatus();
      }
    }
    else {
      this.changeWifiStatus();
    }
  }

  updateStatus = () => {
    // Wi-fi status
    const interval = setInterval(() => {
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
        .then(res => res.json())
        .then(data => this.setState({ status: data.status }));
    }, 30000);

    this.setState({ interval: interval });
  }

  changeWifiStatus = () => {
    this.showTurningWifiOnOffDimmer();
    // Envia o contrário do estado atual do checkbox
    let data = JSON.stringify({ isWifiOn: !this.state.isWifiOn });

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "isWifiOn_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        // esperar 5 segundos e tentar pegar as informações novamente
        setTimeout(() => {
          this.retrieveData();
        }, 5000);
      })
      .catch((error) => {
        // Senão, só avise que não deu certo, mas mantenha o estado do botão
        alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + error);
        this.hideTurningWifiOnOffDimmer();
      });
  }

  getWifiImage = (signalIntensity) => {
    if (signalIntensity >= 75) {
      return `${process.env.PUBLIC_URL}/images/100.png`;
    }
    else if (signalIntensity >= 50 && signalIntensity < 75) {
      return `${process.env.PUBLIC_URL}/images/75.png`;
    }
    else if (signalIntensity >= 25 && signalIntensity < 50) {
      return `${process.env.PUBLIC_URL}/images/50.png`;
    }
    else {
      return `${process.env.PUBLIC_URL}/images/25.png`;
    }
  }

  buildWifiList = (wifiList) => {
    let wifiDropdownOptions = [];

    for (let i = 0; i < wifiList.length; i++) {
      wifiDropdownOptions.push({
        key: i,
        text: wifiList[i].name,
        value: wifiList[i].name,
        image: { avatar: true, src: this.getWifiImage(wifiList[i].signalIntensity) }
      });
    }

    return wifiDropdownOptions;
  }

  // ----------------- Dimmers -----------------
  showLoadingDimmer = () => this.setState({ isLoadingDimmerActive: true })
  hideLoadingDimmer = () => this.setState({ isLoadingDimmerActive: false })

  showConfigDimmer = () => this.setState({ isConfigDimmerActive: true })
  hideConfigDimmer = () => this.setState({ isConfigDimmerActive: false })

  showLoadingConfigDimmer = () => this.setState({ isLoadingConfigDimmerActive: true })
  hideLoadingConfigDimmer = () => this.setState({ isLoadingConfigDimmerActive: false })

  showUpdateHostnameDimmer = () => this.setState({ isUpdateHostnameDimmerActive: true })
  hideUpdateHostnameDimmer = () => this.setState({ isUpdateHostnameDimmerActive: false })

  showTurningWifiOnOffDimmer = () => {
    this.setState({
      isTurnningWifiOnOffDimmerActive: true,
      turningWifiOnOffText: this.state.isWifiOn ? Strings.TURNING_WLAN_OFF_WAITING : Strings.TURNING_WLAN_ON_WAITING
    });
  }

  hideTurningWifiOnOffDimmer = () => {
    this.setState({
      isTurnningWifiOnOffDimmerActive: false,
      turningWifiOnOffText: ""
    });
  }

  // ----------------- Form Change -----------------
  handleHostnameChange = (e, { value }) => {
    this.setState({ hostname: value });
  }

  onWifiModeDropdownChange = (e, { value }) => {
    this.setState({ wifiMode: value });
  }

  onHiddenSSIDDropdownChange = (e, { value }) => {
    this.setState({
      hiddenSSID: value,
      wifiName: ""
    }, () => {
      this.switchWifiNameFieldsVisibility();
    });
  }

  switchWifiNameFieldsVisibility = () => {
    if (this.state.hiddenSSID) {
      document.getElementById("wifi-name-input").style.visibility = "visible";
      document.getElementById("wifi-name-input").style.display = "block";
      document.getElementById("wifi-name-dropdown").style.visibility = "hidden";
      document.getElementById("wifi-name-dropdown").style.display = "none";
    }
    else {
      document.getElementById("wifi-name-input").style.visibility = "hidden";
      document.getElementById("wifi-name-input").style.display = "none";
      document.getElementById("wifi-name-dropdown").style.visibility = "visible";
      document.getElementById("wifi-name-dropdown").style.display = "block";
    }
  }

  onWifiNameDropdownChange = (e, { value }) => {
    this.setState({ wifiName: value });
  }

  onWifiNameNameChange = (e, { value }) => {
    this.setState({ wifiName: value });
  }

  handleAddressChange = (e, { value }) => {
    this.setState({ wifiAddr: value });
  }

  handleMaskChange = (e, { value }) => {
    this.setState({ wifiNetmask: value });
  }

  handleGatewayChange = (e, { value }) => {
    this.setState({ wifiGateway: value });
  }

  handleDNSChange = (e, { value }) => {
    this.setState({ wifiDNS: value });
  }

  handlePasswordChange = (e, { value }) => {
    this.setState({ wifiPwd: value });
  }

  handlePasswordEyeButtonClick = () => {
    if (this.state.pwdType === "password") {
      this.setState({
        pwdType: "text",
        pwdIcon: "eye"
      });
    }
    else {
      this.setState({
        pwdType: "password",
        pwdIcon: "eye slash"
      });
    }
  }

  // ----------------- Config Modal -----------------
  openAlterConfigModal = () => {
    this.setState({ isAlterConfigModalOpen: true });
  }

  closeAlterConfigModal = () => {
    this.setState({ isAlterConfigModalOpen: false });
  }

  sendHostnameInformation = () => {

    if (!UtilsInstance.validadeHostnameLength(this.state.hostname)) {
      alert(Strings.INVALID_HOSTNAME_1);
    }
    else if (!UtilsInstance.simpleValidadeHostname(this.state.hostname)) {
      alert(Strings.INVALID_HOSTNAME_2);
    }
    else {
      let data = JSON.stringify({
        hostname: this.state.hostname,
      });

      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "configHostname_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.handleUpdateCycles();
        })
        .catch((error) => {
          alert(Strings.HOSTNAME_CONFIG_ERROR + Strings.ERROR_REASON + error);
        });
    }
  }

  handleUpdateCycles = () => {
    this.showUpdateHostnameDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_WAITING_2, "");
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.handleAlterConfigurationStatus, 2000) });
  }

  handleAlterConfigurationStatus = () => {
    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_DONE, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_CONFIG_DONE, "");
            this.hideUpdateHostnameDimmer();
            alert(Strings.HOSTNAME_CONFIG_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING + error);
      });
  }

  sendWifiConfigInformation = async () => {
    if (this.state.wifiMode === Constants.DHCP_MODE) {
      this.sendWifiDHCPConfigInformation();
    }
    else if (this.state.wifiMode === Constants.FIXED_IP_MODE) {
      this.sendWifiFixedIpConfigInformation();
    }
  }

  sendWifiDHCPConfigInformation = async () => {
    this.closeAlterConfigModal();

    let isWifiDNSEmpty = this.state.wifiDNS === "";
    let isWifiDNSValid = UtilsInstance.validateIPAddress(this.state.wifiDNS);
    // console.log(true);

    if ((!isWifiDNSEmpty && !isWifiDNSValid)) {

      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      if (!isWifiDNSEmpty && !isWifiDNSValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_DNS);
      }

      alert(invalidInformationString);
    }
    else {

      let data = JSON.stringify({
        wifiMode: this.state.wifiMode,
        hiddenSSID: this.state.hiddenSSID,
        wifiName: this.state.wifiName,
        wifiAddr: "",
        wifiGateway: "",
        wifiNetmask: "",
        wifiDNS: this.state.wifiDNS,
        wifiPwd: this.state.wifiPwd,
      });

      // Get the old configuration data to compare with the new to see if anything changed
      let previousConfigData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      // If nothing was modified, alert the user and do nothing else
      if (this.state.wifiMode === previousConfigData.wifiMode
        && this.state.wifiName === previousConfigData.wifiName
        && this.state.wifiPwd === previousConfigData.wifiPwd
        && this.state.wifiDNS === previousConfigData.wifiDNS) {
        alert(Strings.CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN);
      }
      // If the IP / gateway / mask was modified, we need to handle the update in another way
      else {
        this.showConfigDimmer();

        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "configWifi_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.UPDATE_WLAN_CONFIG_SUCCESS);
            this.retrieveData();
          })
          .catch(() => {
            alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + Strings.UPDATE_WLAN_CONFIG_ERROR);
          })
          .finally(this.hideConfigDimmer);
      }
    }
  }

  sendWifiFixedIpConfigInformation = async () => {
    this.closeAlterConfigModal();

    let cleanedIp = UtilsInstance.removeLeadingZeros(this.state.wifiAddr, UtilsInstance);
    let cleanedNetmask = UtilsInstance.removeLeadingZeros(this.state.wifiNetmask, UtilsInstance);
    let cleanedGateway = UtilsInstance.removeLeadingZeros(this.state.wifiGateway, UtilsInstance);
    let cleanedDNS = UtilsInstance.removeLeadingZeros(this.state.wifiDNS, UtilsInstance);

    let isWifiIpValid = UtilsInstance.validateIPAddress(cleanedIp);
    let isWifiZeroIp = UtilsInstance.isZeroIP(cleanedIp);
    let isWifiNetmaskZeroIp = UtilsInstance.isZeroIP(cleanedNetmask);
    let isWifiIpLoopback = UtilsInstance.isIPLoopback(cleanedIp);
    let isWifiBroadcastIp = UtilsInstance.isBroadcastAddress(cleanedIp, cleanedNetmask, UtilsInstance);
    let isWifiNetworkIp = UtilsInstance.isNetworkAddress(cleanedIp, cleanedNetmask, UtilsInstance);
    let isWifiSubmaskValid = UtilsInstance.validateSubmask(cleanedNetmask);
    let isWifiGatewayValid = UtilsInstance.validateIPAddress(cleanedGateway);
    let isWifiGatewayBroadcastIp = UtilsInstance.isBroadcastAddress(cleanedGateway, cleanedNetmask, UtilsInstance);
    let isWifiGatewayNetworkIp = UtilsInstance.isNetworkAddress(cleanedGateway, cleanedNetmask, UtilsInstance);

    let isWifiDNSEmpty = cleanedDNS === "";
    let isWifiDNSValid = UtilsInstance.validateIPAddress(cleanedDNS);
    let subnetsOverlap = UtilsInstance.subnetsOverlap(
      this.state.addr,
      this.state.netmask,
      cleanedIp,
      cleanedNetmask,
      UtilsInstance
    );

    if (!isWifiIpValid
      || isWifiZeroIp
      || isWifiNetmaskZeroIp
      || isWifiIpLoopback
      || isWifiBroadcastIp
      || isWifiNetworkIp
      || !isWifiSubmaskValid
      || !isWifiGatewayValid
      || isWifiGatewayBroadcastIp
      || isWifiGatewayNetworkIp
      || (!isWifiDNSEmpty && !isWifiDNSValid)
      || subnetsOverlap) {

      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      if (!isWifiIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      if (isWifiIpLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP);
      }
      if (isWifiZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.ZERO_IP_MSG);
      }
      if (isWifiNetmaskZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.ZERO_IP_MASK_MSG);
      }
      if (isWifiBroadcastIp) {
        invalidInformationString = invalidInformationString.concat(Strings.BROADCAST_IP_MSG);
      }
      if (isWifiNetworkIp && !isWifiZeroIp) {
        invalidInformationString = invalidInformationString.concat(Strings.NETWORK_IP_MSG);
      }
      if (!isWifiSubmaskValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_SUBMASK);
      }
      if (!isWifiGatewayValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_GATEWAY);
      }
      if (isWifiGatewayBroadcastIp) {
        invalidInformationString = invalidInformationString.concat(Strings.BROADCAST_GATEWAY_MSG);
      }
      if (isWifiGatewayNetworkIp) {
        invalidInformationString = invalidInformationString.concat(Strings.NETWORK_GATEWAY_MSG);
      }
      if (!isWifiDNSEmpty && !isWifiDNSValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_DNS);
      }

      if (isWifiIpValid
        && !isWifiIpLoopback
        && !isWifiZeroIp
        && !isWifiNetmaskZeroIp
        && !isWifiBroadcastIp
        && !isWifiNetworkIp
        && isWifiSubmaskValid
        && isWifiGatewayValid
        && !isWifiGatewayBroadcastIp
        && !isWifiGatewayNetworkIp
        && (isWifiDNSEmpty || isWifiDNSValid)
        && subnetsOverlap) {
        invalidInformationString = invalidInformationString.concat(Strings.SUBNET_OVERLAP_WLAN);
      }

      alert(invalidInformationString);
    }
    else {
      let gtway = "";

      if (cleanedGateway === "") {
        gtway = "0.0.0.0";
      } else {
        gtway = cleanedGateway;
      }

      let data = JSON.stringify({
        wifiMode: this.state.wifiMode,
        hiddenSSID: this.state.hiddenSSID,
        wifiName: this.state.wifiName,
        wifiAddr: cleanedIp,
        wifiGateway: gtway,
        wifiNetmask: cleanedNetmask,
        wifiDNS: cleanedDNS,
        wifiPwd: this.state.wifiPwd,
      });

      // Get the old configuration data to compare with the new to see if anything changed
      let previousConfigData = await fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      // If nothing was modified, alert the user and do nothing else
      if (this.state.wifiMode === previousConfigData.wifiMode
        && cleanedIp === previousConfigData.wifiAddr
        && gtway === previousConfigData.wifiGateway
        && cleanedNetmask === previousConfigData.wifiNetmask
        && this.state.wifiName === previousConfigData.wifiName
        && this.state.wifiPwd === previousConfigData.wifiPwd
        && cleanedDNS === previousConfigData.wifiDNS) {
        alert(Strings.CHANGE_AT_LEAST_ONE_OF_THE_FIELDS_WLAN);
      }
      // If the IP / gateway / mask was modified, we need to handle the update in another way
      else {
        this.showConfigDimmer();

        fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "configWifi_POST", {
          method: "POST",
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          },
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            alert(Strings.UPDATE_WLAN_CONFIG_SUCCESS);
            this.retrieveData();
          })
          .catch(() => {
            alert(Strings.SEND_CONFIG_FAILURE + Strings.ERROR_REASON + Strings.UPDATE_WLAN_CONFIG_ERROR);
          })
          .finally(this.hideConfigDimmer);
      }
    }
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
    this.updateStatus();
  }

  componentWillUnmount() {
    clearInterval(this.state.interval);
  }

  render() {
    const isLoadingDimmerActive = this.state.isLoadingDimmerActive;

    const isTurnningWifiOnOffDimmerActive = this.state.isTurnningWifiOnOffDimmerActive;
    const turningWifiOnOffText = this.state.turningWifiOnOffText;

    const wifiNameList = this.state.wifiNameList;

    const isLoadingConfigDimmerActive = this.state.isLoadingConfigDimmerActive;

    const isConfigDimmerActive = this.state.isConfigDimmerActive;

    const isUpdateHostnameDimmerActive = this.state.isUpdateHostnameDimmerActive;

    return (
      <div style={configStyle}>

        <Segment style={segmentStyle}>
          <Divider horizontal>
            Hostname
            <Popup position='bottom center' hoverable pinned wide="very"
              trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
              <Popup.Content>
                <p>{Strings.HOSTNAME_POPUP_1}</p>
                <p>{Strings.HOSTNAME_POPUP_2}</p>
              </Popup.Content>
            </Popup>
          </Divider>

          <Form style={formStyle} onSubmit={this.sendHostnameInformation}>

            <Form.Field inline>
              <label style={labelStyle}>Hostname</label>
              <Input style={inputStyle}
                disabled={!this.state.isWifiOn}
                placeholder="Hostname"
                value={this.state.hostname}
                onChange={this.handleHostnameChange} />
            </Form.Field>

            <Button
              disabled={!this.state.isWifiOn}
              color="teal"
              type="submit" >
              {Strings.SETUP}
            </Button>
          </Form>

        </Segment>

        <Grid centered columns={2} doubling>

          <Grid.Row>

            <Grid.Column stretched>
              <Segment style={segmentStyle}>
                <Divider horizontal>
                  {Strings.WLAN_STATUS}
                  <Popup position='bottom center' hoverable pinned wide
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.WLAN_STATUS_POPUP_1}</p>
                      <p>{Strings.WLAN_STATUS_POPUP_2}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>
                <Checkbox
                  toggle
                  label={<label>{this.state.isWifiOn ? Strings.WLAN_ADAPTER_ON : Strings.WLAN_ADAPTER_OFF}</label>}
                  onChange={this.toggleIsWifiOnCheckbox}
                  checked={this.state.isWifiOn}
                />
                <Dimmer active={isTurnningWifiOnOffDimmerActive} >
                  <Loader>{turningWifiOnOffText}</Loader>
                </Dimmer>
              </Segment>
            </Grid.Column>

            <Grid.Column stretched>
              <Segment style={segmentStyle}>
                <Divider horizontal>
                  {Strings.CONNECTION_STATUS}
                  <Popup position='bottom center' hoverable pinned wide
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p>{Strings.CONNECTION_STATUS_POPUP_1}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>
                {this.getWifiStatusText(this.state.status)}
              </Segment>
            </Grid.Column>

          </Grid.Row>

          <Grid.Row>
            <Grid.Column stretched>
              <Segment>

                <Divider horizontal>
                  {Strings.WLAN_CONFIG}
                  <Popup position='bottom center' hoverable pinned wide="very"
                    trigger={<Icon name="question circle" color="teal" style={questionIconStyle} />}>
                    <Popup.Content>
                      <p><b>{Strings.PS_1} </b>{Strings.WLAN_CONFIG_POPUP_1}</p>
                      <p><b>{Strings.PS_2} </b>{Strings.WLAN_CONFIG_POPUP_2}</p>
                      <p><b>{Strings.PS_3} </b>{Strings.WLAN_CONFIG_POPUP_3}</p>
                      <p>• {Strings.WLAN_CONFIG_POPUP_4}</p>
                      <p>• {Strings.WLAN_CONFIG_POPUP_5}</p>
                    </Popup.Content>
                  </Popup>
                </Divider>

                <Form style={formStyle} onSubmit={this.openAlterConfigModal}>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.MODE}</label>
                    <Dropdown
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.DHCP}
                      style={inputStyle}
                      selection
                      scrolling
                      value={this.state.wifiMode}
                      options={wifiModeList}
                      onChange={this.onWifiModeDropdownChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.HIDDEN_SSID}</label>
                    <Dropdown
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.NO}
                      style={inputStyle}
                      selection
                      scrolling
                      value={this.state.hiddenSSID}
                      options={hiddenSSIDList}
                      onChange={this.onHiddenSSIDDropdownChange} />
                  </Form.Field>

                  <Form.Field id="wifi-name-input" inline>
                    <label style={labelStyle}>{Strings.NETWORK_NAME_1}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.NETWORK_NAME_1}
                      value={this.state.wifiName}
                      onChange={this.onWifiNameNameChange} />
                  </Form.Field>

                  <Form.Field id="wifi-name-dropdown" inline>
                    <label style={labelStyle}>{Strings.NETWORK_NAME_1}</label>
                    <Dropdown
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.NETWORK_NAME_1}
                      style={inputStyle}
                      selection
                      scrolling
                      value={this.state.wifiName}
                      options={wifiNameList}
                      onChange={this.onWifiNameDropdownChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.IP}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn || this.state.wifiMode === Constants.DHCP_MODE}
                      placeholder="192.168.0.2"
                      value={this.state.wifiAddr}
                      onChange={this.handleAddressChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.SUBMASK}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn || this.state.wifiMode === Constants.DHCP_MODE}
                      placeholder="255.255.255.0"
                      value={this.state.wifiNetmask}
                      onChange={this.handleMaskChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.GATEWAY}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn || this.state.wifiMode === Constants.DHCP_MODE}
                      placeholder="192.168.0.1"
                      value={this.state.wifiGateway}
                      onChange={this.handleGatewayChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.DNS}{Strings.OPTIONAL}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder="192.168.0.1"
                      value={this.state.wifiDNS}
                      onChange={this.handleDNSChange} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.PASSWORD}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      type={this.state.pwdType}
                      placeholder={Strings.PASSWORD}
                      value={this.state.wifiPwd}
                      onChange={this.handlePasswordChange}
                      action={
                        <Button
                          type="button"
                          color="teal"
                          icon={this.state.pwdIcon}
                          onClick={this.handlePasswordEyeButtonClick} />
                      }
                    />
                  </Form.Field>

                  <Button
                    disabled={!this.state.isWifiOn}
                    color="teal"
                    type="submit" >
                    {Strings.SETUP}
                  </Button>
                </Form>

                <Dimmer active={isConfigDimmerActive} >
                  <Loader>{Strings.SEND_WLAN_CONFIG_WAITING}</Loader>
                </Dimmer>

                <Dimmer active={isLoadingConfigDimmerActive} >
                  <Loader>{Strings.LOADING_WAITING}</Loader>
                </Dimmer>

              </Segment>
            </Grid.Column>

            <Grid.Column stretched>
              <Segment>
                <Divider horizontal>{Strings.WLAN_INFO}</Divider>

                <Form style={formStyle}>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.IP}</label>
                    <Input
                      style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.IP_PLACEHODLER}
                      value={this.state.ip} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.SSID}</label>
                    <Input
                      style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.SSID_PLACEHOLDER}
                      value={this.state.ssid} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.MAC}</label>
                    <Input style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.MAC_PLACEHOLDER}
                      value={this.state.mac} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.SIGNAL_STRENGTH}</label>
                    <Input
                      style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.SIGNAL_STRENGTH_PLACEHOLDER}
                      value={this.state.signalStrength} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.FREQUENCY}</label>
                    <Input
                      style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.FREQUENCY_PLACEHOLDER}
                      value={this.state.signalFrequency} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.CHANNEL}</label>
                    <Input
                      style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.CHANNEL_PLACEHOLDER}
                      value={this.state.channel} />
                  </Form.Field>

                  <Form.Field inline>
                    <label style={labelStyle}>{Strings.QUALITY}</label>
                    <Input
                      style={inputStyle}
                      disabled={!this.state.isWifiOn}
                      placeholder={Strings.QUALITY_PLACEHOLDER}
                      value={this.state.signalQuality} />
                  </Form.Field>

                </Form>

                <Dimmer active={isLoadingDimmerActive} >
                  <Loader>{Strings.LOADING_WAITING}</Loader>
                </Dimmer>

              </Segment>
            </Grid.Column>
          </Grid.Row>

        </Grid>

        <Modal centered basic size='small' open={this.state.isAlterConfigModalOpen}>
          <Modal.Content content={Strings.ALTER_MONITOR_WLAN_CONFIG} />
          <Modal.Actions>
            <Button color='red' inverted onClick={this.closeAlterConfigModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button color='green' inverted onClick={this.sendWifiConfigInformation}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Dimmer page active={isUpdateHostnameDimmerActive}>
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer>
      </div>

    );
  }
}

const configStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

const segmentStyle = {
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(WLANConfig);
